import { filter, isArray, last, sortBy } from 'lodash';
import { IModelSet } from 'Scripts/modelSet';
import validator from '../validator';
import valueFilters from '../valueFilters';
import statusLogItemModel, { IStatusLogItem } from './statusLogItemModel';

export interface IStatusLogged<StatusType = string> {
	statusLog?: IModelSet<IStatusLogItem>;
	currentStatusItem?: IStatusLogItem;
	currentStatus: StatusType;
	currentStatusDate?: Date;
	getMostRecentStatusByStatus(status: StatusType | StatusType[]): IStatusLogItem;
}
export default (defaultStatus, initializeLog = false) => {
	return {
		statusLog: {
			setFilters: valueFilters.toModelSet(statusLogItemModel),
			rules: validator.validModel(statusLogItemModel.rules()),
			defaultValue: initializeLog? []: undefined
		},
		currentStatusItem: {
			writable: false,
			nonSerialized: true
		},
		_get_currentStatusItem: function () {
			return last(sortBy(this.statusLog, 'relayId'));
		},
		currentStatus: {
			writable: false,
			nonSerialized: true
		},
		_get_currentStatus: function () {
			const item = this.currentStatusItem;

			return item ? item.status : defaultStatus;
		},
		currentStatusDate: {
			writable: false,
			nonSerialized: true
		},
		_get_currentStatusDate: function () {
			const item = this.currentStatusItem;

			return item && item.dateCreated;
		},
		getMostRecentStatusByStatus: function (status) {
			const statuses = isArray(status) ? status : [status];
			return last(sortBy(filter(this.statusLog, s => statuses.indexOf(s.status) !== -1), 'dateCreated'));
		}
	};
};